import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'
import store from '../store' // Import the store
import Home from '../views/Pages/home.vue'
import Main from '../views/Main.vue'
import Verify from '../views/Verify.vue'
import validatecert from '../views/validatecert.vue'
import quickscan from '../views/quickscan.vue'

// subprofile
import OrganisationDashboard from '../views/Pages/OrganisationDashboard.vue'
import ProjectProfile from '../views/Project/ProjectProfile.vue'
import Reports from '../views/Project/Reports.vue'
import Pdf from '../views/Project/pdf.vue'
import Certificate from '../views/Project/certificate.vue'

import Single from '../views/Project/Single.vue'

// scanner
import Scan from '../views/Project/Scan.vue'
import step2 from '../views/Project/Scanner/step2.vue'
import step3 from '../views/Project/Scanner/step3.vue'

// admin
import Category from '../views/Admin/Category.vue'
import Catalogue from '../views/Admin/Catalogue.vue'
import Setting from '../views/Admin/Setting.vue'

Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'Main',
    component: Main,
    children:[
      {
        path: '',
        name: 'dashboard',
        component: Home,
      }
    ],
    meta: { requiresAuth: true } // Add meta field for authentication
  },
  {
    path: '/verify',
    component: Verify
  },
  {
    path: '/validatecert',
    component: validatecert
  },
  {
    path: '/quickscan',
    component: quickscan
  },
  {
    path: '/admin',
    component: Main,
    children: [
      {
        path: 'category',
        component: Category
      },
      {
        path: 'catalogue',
        component: Catalogue
      },
      {
        path: 'settings',
        component: Setting
      }
    ],
    meta: { requiresAuth: true } // Add meta field for authentication
  },
  {
    path: '/dashboard',
    redirect: '/'
  },
  {
    path: '/:org_id',
    name: 'organisation',
    component: Main,
    children: [
      {
        path: 'dashboard',
        component: OrganisationDashboard
      },
      {
        path: 'dashboard/:prod_id',
        component: ProjectProfile
      },
      {
        path: '/:org_id/vulnerability/:prod_id',
        component: Reports
      },
      {
        path: '/:org_id/vulnerability/:prod_id/:report_id',
        component: Single
      },
      {
        path: '/:org_id/pdf/:prod_id',
        component: Pdf
      },
      {
        path: '/:org_id/certificate/:prod_id',
        component: Certificate
      },
      {
        path: '/:org_id/scan/:prod_id',
        component: Scan
      },
      {
        path: '/:org_id/scan/:prod_id/step/1',
        redirect: '/:org_id/scan/:prod_id'
      },
      {
        path: '/:org_id/scan/:prod_id/step/2',
        component: step2
      },
      {
        path: '/:org_id/scan/:prod_id/step/3',
        component: step3
      },
    ],
    meta: { requiresAuth: true } // Add meta field for authentication
  },
];


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  const isAuthenticated = store.getters['auth/isAuthenticated'];
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth && !isAuthenticated) {
    // If the route requires authentication and the user is not authenticated,
    // dispatch the logout action to redirect to the SSO login page.
    store.dispatch('auth/logout');
  } else {
    // If the route does not require authentication or the user is authenticated,
    // proceed with the navigation.
    if (isAuthenticated && to.params.org_id) {
      try {
        // First API call
        const response = await axios.get(
          Vue.prototype.$server + 'organisation/' + to.params.org_id + '/project'
        );

        if (response?.data?.success) {
          sessionStorage.setItem('org', JSON.stringify(response.data.data));
        }

        // Second API call
        const res = await axios.get(
          Vue.prototype.$server + 'organisation/' + to.params.org_id
        );

        if (res?.data?.success) {
          localStorage.setItem('organisation', JSON.stringify(res.data.organisation));
        }
      } catch (error) {
        console.error('Error:', error);
        // If there's an error fetching organisation data, it's better to redirect
        // to a safe place, like the dashboard, to avoid inconsistent state.
        next('/');
        return;
      }
    }
    next();
  }
});


export default router
